
var showRmEiModal;
(function() {
  var shown = false;

  showRmEiModal = function showModal() {
    if (shown || sessionStorage.getItem('rm_ei_shown')) return;
    shown = true;
    sessionStorage.setItem('rm_ei_shown', '1');

    var overlay = document.createElement('div');
    overlay.id = 'rm-ei-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;padding:1rem;animation:rmFadeIn 0.25s ease;';

    overlay.innerHTML = `
      <style>
        @keyframes rmFadeIn{from{opacity:0}to{opacity:1}}
        @keyframes rmSlideUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
        #rm-ei-card{animation:rmSlideUp 0.3s ease;}
        #rm-ei-card input:focus{border-color:#C4704B !important;outline:none;}
        @media(max-width:600px){
          #rm-ei-card{flex-direction:column !important;max-height:90vh;overflow-y:auto;}
          #rm-ei-image-col{display:none !important;}
        }
      </style>

      <div id="rm-ei-card" style="background:#fff;border-radius:20px;overflow:hidden;display:flex;max-width:780px;width:100%;box-shadow:0 24px 80px rgba(0,0,0,0.22);position:relative;">

        <!-- Close button -->
        <button id="rm-ei-close" style="position:absolute;top:14px;right:16px;background:rgba(255,255,255,0.9);border:none;border-radius:50%;width:32px;height:32px;cursor:pointer;font-size:1.1rem;color:#888;z-index:10;display:flex;align-items:center;justify-content:center;line-height:1;">✕</button>

        <!-- Left: lifestyle image -->
        <div id="rm-ei-image-col" style="flex:0 0 42%;position:relative;min-height:440px;">
          <img src="https://cdn.shopify.com/s/files/1/0788/7477/1683/t/2/assets/optin-lifestyle.jpg?v=1774030356" alt="Parent and child" style="width:100%;height:100%;object-fit:cover;object-position:center top;">
          <div style="position:absolute;inset:0;background:linear-gradient(to right,transparent 60%,#fff 100%);"></div>
        </div>

        <!-- Right: form -->
        <div style="flex:1;padding:2.75rem 2.5rem 2.5rem;">
          <div style="font-family:'Instrument Sans',Arial,sans-serif;font-size:0.68rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#C4704B;margin-bottom:0.6rem;">Free Download</div>

          <h2 style="font-family:'Playfair Display',Georgia,serif;font-size:1.75rem;font-weight:700;color:#2C1E14;margin:0 0 0.6rem;line-height:1.2;">The Mighty Kid<br>Blueprint</h2>

          <p style="font-family:'Instrument Sans',Arial,sans-serif;font-size:0.88rem;color:#777;margin:0 0 0.5rem;line-height:1.65;">What most parents don't know — and what to do about it.</p>

          <p style="font-family:\'Helvetica Neue\',Arial,sans-serif;font-size:0.88rem;color:#777;line-height:1.7;margin:0 0 1.25rem;">Most parents have no idea their child is quietly missing the nutrients that matter most — until they see the signs.</p>
              <p style="font-family:\'Helvetica Neue\',Arial,sans-serif;font-size:0.88rem;color:#777;line-height:1.7;margin:0 0 1.25rem;">This free guide covers the 5 most common gaps — with clear, practical steps for each one. 24 pages. No fluff.</p>

          <form id="rm-ei-form" style="display:flex;flex-direction:column;gap:9px;">
            <input type="text" id="rm-ei-name" placeholder="First name" required
              style="padding:0.82rem 1rem;border:1.5px solid #e5dbd3;border-radius:8px;font-size:0.9rem;font-family:'Instrument Sans',Arial,sans-serif;color:#2C1E14;background:#fafafa;">
            <input type="email" id="rm-ei-email" placeholder="Email address" required
              style="padding:0.82rem 1rem;border:1.5px solid #e5dbd3;border-radius:8px;font-size:0.9rem;font-family:'Instrument Sans',Arial,sans-serif;color:#2C1E14;background:#fafafa;">
            <button type="submit" id="rm-ei-btn"
              style="padding:0.9rem;background:#C4704B;color:#fff;border:none;border-radius:8px;font-size:0.95rem;font-weight:700;cursor:pointer;font-family:'Instrument Sans',Arial,sans-serif;">
              Send Me the Blueprint →
            </button>
          </form>

          <div id="rm-ei-success" style="display:none;margin-top:0.75rem;background:#f2f8f1;border-left:4px solid #7A8C6E;border-radius:6px;padding:0.8rem 1rem;font-family:'Instrument Sans',Arial,sans-serif;font-size:0.88rem;color:#4a6741;">
            ✅ Check your inbox — on its way!
          </div>

          <p style="font-family:'Instrument Sans',Arial,sans-serif;font-size:0.72rem;color:#bbb;margin:0.85rem 0 0;text-align:center;">No spam. Unsubscribe anytime.</p>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    document.getElementById('rm-ei-close').onclick = function() { overlay.remove(); };
    overlay.addEventListener('click', function(e){ if(e.target===overlay) overlay.remove(); });

    var btn = document.getElementById('rm-ei-btn');
    btn.addEventListener('mouseover', function(){ this.style.background='#a85a38'; });
    btn.addEventListener('mouseout', function(){ this.style.background='#C4704B'; });

    document.getElementById('rm-ei-form').addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('rm-ei-email').value;
      var name  = document.getElementById('rm-ei-name').value;
      btn.textContent = 'Sending...'; btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RdbCaj',{
        method:'POST',headers:{'content-type':'application/json','revision':'2024-07-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'exit-intent-popup',
          profile:{data:{type:'profile',attributes:{email:email,first_name:name}}}},
          relationships:{list:{data:{type:'list',id:'WZ2yjR'}}}}})
      }).then(function(){
        document.getElementById('rm-ei-success').style.display='block';
        document.getElementById('rm-ei-form').style.display='none';
        setTimeout(function(){ overlay.remove(); }, 3000);
      }).catch(function(){ btn.textContent='Send Me the Blueprint →'; btn.disabled=false; });
    });
  };

  // Desktop: exit intent on mouse leave top
  var gracePeriod = false;
  setTimeout(function(){ gracePeriod=true; }, 5000);
  document.addEventListener('mouseleave', function(e){
    if(gracePeriod && e.clientY < 10) showModal();
  });

  // Mobile: 45s timer
  setTimeout(function(){ showModal(); }, 45000);
})();
